export default "__VITE_ASSET__BcNa47Fo__"